import * as React from 'react'
import cx from 'classnames'

import { SliceComponent } from 'components/RichTextEditor/types'

import cm from './Url.module.css'

const Url: SliceComponent = ({ children, isSelected }) => {
  return <span className={cx('text-primary', isSelected && cm.selected)}>{children}</span>
}

export default Url
